import request from '@/api/request'

// 公开课列表
export const getBktOpenClassListPage = (params) => {
    return request({
        url: 'acm/adm/bktOpenClass/getListPage',
        method: 'get',
        params
    })
}

// 添加公开课
export const addBktOpenClass = (data) => {
    return request({
        url: 'acm/adm/bktOpenClass/addBktOpenClass',
        method: 'post',
        data
    })
}

// 修改公开课
export const updateBktOpenClass = (data) => {
    return request({
        url: 'acm/adm/bktOpenClass/updateBktOpenClass',
        method: 'post',
        data
    })
}

// 修改公开课序号
export const updateSortNum = (data) => {
    return request({
        url: 'acm/adm/bktOpenClass/updateSortNum',
        method: 'post',
        data
    })
}

// 修改公开课发布状态
export const updatePublishStatus = (data) => {
    return request({
        url: 'acm/adm/bktOpenClass/updatePublishStatus',
        method: 'post',
        data
    })
}